import classnames from 'classnames';
import React from 'react';
import { Icon, IconName } from '../Icon';

export type EmptyStateProps = {
  message?: string;
  hasBorder?: boolean;
  variant?: 'market' | 'documents' | 'filters';
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  hasBorder,
  variant = 'market',
}) => {
  const iconName = {
    market: 'EmptyMarket' as IconName,
    documents: 'EmptyFolder' as IconName,
    filters: 'Insights' as IconName,
  }[variant];

  return (
    <div
      className={classnames(
        'flex h-full flex-col items-center',
        {
          'border-grey-300 border-b border-t p-6':
            (variant === 'market' || variant === 'filters') && hasBorder,
        },
        {
          'border-grey-300 p-120px border-b': variant === 'documents',
        },
      )}
    >
      <span className="text-grey-300 h-28 w-28">
        <Icon name={iconName} />
      </span>
      {message && (
        <span
          className={classnames(
            'text-grey-600 font-regular max-w-622px text-center',
            {
              'text-base': message.length < 60,
            },
            variant === 'documents' ? 'mt-1' : 'mt-4',
          )}
        >
          {message}
        </span>
      )}
    </div>
  );
};
